import {FaPlus, FaTrash} from "react-icons/fa";
import React from "react";

const ShopTimeApproversTable = (setSelectedRow, setFormModal, setDeleteModal) => {
    return [
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            id: 'actions',
            Header: () => {
                return (
                    <FaPlus
                        color='#22af47'
                        size={18}
                        title="Create"
                        onClick={() => {
                            setSelectedRow({});
                            setFormModal({isOpen: true});
                        }}
                    />
                )
            },
            Cell: (cell) => {
                const row = cell.row.original;
                return (
                    <>
                        <FaTrash
                            className="actions"
                            title="Delete"
                            onClick={() => {
                                const msg = <p>Are you sure you want to delete this Approver <b>{row.name}</b> from Approvers list?</p>;
                                setSelectedRow(row);
                                setDeleteModal({
                                    message: msg,
                                    isOpen: true,
                                })
                            }}
                        />
                    </>
                )
            }
        }
    ];
}

export default ShopTimeApproversTable;



